import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tv-confirmation-due-dialog',
  templateUrl: 'confirmation.due.dialog.component.html',
  styles: [`.button-align {text-align: right}`]
})
export class ConfirmationDueDialogComponent {
  message: string;
  description: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmationDueDialogComponent>) {
    if (data) {
      this.message = data.message || this.message;
      this.description = data.description;
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancel(): void {
    this.dialogRef.close(false);
  }

    onDiloagCancel() {
    console.log('popup closed');
    this.dialogRef.close();
  }
}
